import React from 'react';
import { OpenCircle, FinishedCircle, HalfCircle } from 'global/components/icons';

export const TaskStatus = [
  { title: 'Open and Pending', value: 'openPending' },
  { title: 'Open', value: 'open' },
  { title: 'Pending', value: 'pending' },
  { title: 'Closed', value: 'closed' },
  { title: 'Open and Closed', value: 'openClosed' },
];

export const Ownership = [
  { title: 'My Assessments', value: 'my' },
  { title: 'All Assessments', value: 'all' },
];
export const OwnershipTask = [
  { title: 'My Tasks', value: 'my' },
  { title: 'All Tasks', value: 'all' },
];

export const TaskAge = [
  { title: '0-6 days', value: '0-6' },
  { title: '7-20 days', value: '7-20' },
  { title: '21+ days', value: '21-' },
];

export const QualityType = [
  { title: 'Any', value: 1 },
  { title: 'High Quality', value: 2 },
  { title: 'Poor Quality', value: 0 },
];

export const TaskContent = [
  { title: 'BY TITLE', value: 'title' },
  { title: 'BY USERS', value: 'users' },
];

export const EditionStatus = [
  { title: 'Draft', value: 'draft' },
  { title: 'Active', value: 'active' },
  { title: 'De-Activated', value: 'de-activated' },
  { title: 'Archived', value: 'archived' },
];

export const CourseStatus = [
  { title: 'Not Started', value: null, icon: <OpenCircle style={{ marginRight: 5 }} /> },
  { title: 'In Progress', value: [0, 99], icon: <HalfCircle style={{ marginRight: 5 }} /> },
  { title: 'Finished', value: 100, icon: <FinishedCircle style={{ marginRight: 5 }} /> },
];

export const DocTypes = [
  { title: 'Type 1', value: 'type1' },
  { title: 'Type 2', value: 'type2' },
  { title: 'Type 3', value: 'type3' },
  { title: 'Type 4', value: 'type4' },
  { title: 'Type 5', value: 'type5' },
];

export const SuperSets = [
  { title: 'Super 1', value: 'super1' },
  { title: 'Super 2', value: 'super2' },
  { title: 'Super 3', value: 'super3' },
  { title: 'Super 4', value: 'super4' },
  { title: 'Super 5', value: 'super5' },
];

export const UserStatus = [
  { title: 'Active', value: 'active' },
  { title: 'Deactivated', value: 'inactive' },
];

export const UserPermission = [
  { title: 'Create Tasks', value: 'createTasks', match: 'task.create', nav: 'tasks' },
  { title: 'Manage Content', value: 'createLibrary', match: 'library.create', nav: 'library' },
  { title: 'Create Assessments', value: 'createReports', match: 'assessment.create', nav: 'assessments' },
  { title: 'Create Assessment Templates', value: 'createReportTemplates', nav: 'assessments', match: 'assessment_template.create' },
  { title: 'Manage Users', value: 'manageUsers', match: 'user.update' },
  { title: 'Manage Account', value: 'manageAccount', match: 'account.update' },
];

export const RealmTypes = [
  { title: 'Lot', value: 'lot', icon: 'HomeIcon' },
  { title: 'Community', value: 'community', icon: 'CommunityIcon' },
  { title: 'Division', value: 'division', icon: 'DivisionIcon' },
];

export const CourseDisplay = [
  { title: 'User Results', value: 'user' },
  { title: 'Course Results', value: 'edition' },
  { title: 'Location Results', value: 'realm' },
];
